import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["value", "name", "onChange", "onBlur", "multiple", "options", "excludedOptions", "createable", "useRevampedMapItemToChip", "disableCommaInput"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context4, _context5; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context4 = ownKeys(Object(t), !0)).call(_context4, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context5 = ownKeys(Object(t))).call(_context5, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//@ts-nocheck
import SelectChip from "components/mui/Fields/Fields/SelectField/SelectChip";
import MultiDownshift from "components/mui/Fields/Selects/AsyncSelect/MultiDownshift";
import * as React from "react";
import DefaultAutocompleteInputField from "../AutoComplete/DefaultAutocompleteInputField";
import DefaultSuggestionsPopper from "../AutoComplete/DefaultSuggestionsPopper";
import { Typography, Icon, RaiseColors } from "componentLibrary";
import { Chip } from "components/mui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function AutoCompleteSelectInput(_ref) {
  var value = _ref.value,
    name = _ref.name,
    _onChange = _ref.onChange,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple,
    options = _ref.options,
    excludedOptions = _ref.excludedOptions,
    createable = _ref.createable,
    useRevampedMapItemToChip = _ref.useRevampedMapItemToChip,
    _ref$disableCommaInpu = _ref.disableCommaInput,
    disableCommaInput = _ref$disableCommaInpu === void 0 ? false : _ref$disableCommaInpu,
    muiFieldProps = _objectWithoutProperties(_ref, _excluded);
  var itemToString = function itemToString(item) {
    return item ? item.label : "";
  };
  var inputFieldRef = React.useRef();
  var handleBlur = function handleBlur() {
    return onBlur({
      target: {
        name: name
      }
    });
  };
  var initialSelectedItem = null;
  if (multiple) {
    initialSelectedItem = _mapInstanceProperty(value).call(value, function (v) {
      return _findInstanceProperty(options).call(options, function (o) {
        return o.value === v;
      });
    });
  } else if (value) {
    initialSelectedItem = _findInstanceProperty(options).call(options, function (o) {
      return o.value === value;
    });
  }
  return /*#__PURE__*/_jsx("div", {
    ref: inputFieldRef,
    style: {
      width: "100%"
    },
    children: /*#__PURE__*/_jsx(MultiDownshift, {
      multiple: multiple,
      initialSelectedItem: initialSelectedItem,
      itemToString: itemToString,
      onChange: function onChange(nextChoice) {
        var _nextChoice$value;
        var value = (_nextChoice$value = nextChoice === null || nextChoice === void 0 ? void 0 : nextChoice.value) !== null && _nextChoice$value !== void 0 ? _nextChoice$value : "";
        if (multiple) {
          value = _mapInstanceProperty(nextChoice).call(nextChoice, function (item) {
            var _item$value;
            return (_item$value = item === null || item === void 0 ? void 0 : item.value) !== null && _item$value !== void 0 ? _item$value : "";
          });
        }
        return _onChange({
          target: {
            name: name,
            value: value
          }
        });
      },
      onOuterClick: handleBlur,
      onSelect: handleBlur,
      children: function children(downshiftProps) {
        var getInputProps = downshiftProps.getInputProps,
          getLabelProps = downshiftProps.getLabelProps,
          getItemProps = downshiftProps.getItemProps,
          getMenuProps = downshiftProps.getMenuProps,
          itemToString = downshiftProps.itemToString,
          isOpen = downshiftProps.isOpen,
          clearSelection = downshiftProps.clearSelection,
          toggleMenu = downshiftProps.toggleMenu,
          selectedItems = downshiftProps.selectedItems,
          removeItem = downshiftProps.removeItem,
          inputValue = downshiftProps.inputValue,
          selectItem = downshiftProps.selectItem;
        var suggestions = inputValue ? _filterInstanceProperty(options).call(options, function (o) {
          var _context;
          return _indexOfInstanceProperty(_context = o.label.toLowerCase()).call(_context, inputValue.toLowerCase()) !== -1;
        }) : options;
        suggestions = _filterInstanceProperty(suggestions).call(suggestions, function (f) {
          if (multiple) {
            return !_includesInstanceProperty(value).call(value, f.value);
          }
          return value !== f.value;
        });
        if (excludedOptions) {
          suggestions = _filterInstanceProperty(suggestions).call(suggestions, function (f) {
            return !_includesInstanceProperty(excludedOptions).call(excludedOptions, f.value);
          });
        }
        var mapItemToChip = function mapItemToChip(item, index) {
          var _context2;
          return /*#__PURE__*/_jsx(SelectChip, {
            tabIndex: -1,
            label: itemToString(item),
            onDelete: function onDelete() {
              return removeItem(item);
            },
            color: "primary"
          }, _concatInstanceProperty(_context2 = "".concat(index, "#")).call(_context2, itemToString(item)));
        };
        var revampedMapItemToChip = function revampedMapItemToChip(item, index) {
          var _context3;
          return /*#__PURE__*/_jsx(Chip, {
            style: {
              marginTop: "8px",
              backgroundColor: RaiseColors.science200,
              border: "1px solid ".concat(RaiseColors.science900),
              marginRight: "8px"
            },
            tabIndex: -1,
            label: /*#__PURE__*/_jsx(Typography, {
              color: RaiseColors.science900,
              weight: "medium",
              children: itemToString(item)
            }),
            onDelete: function onDelete() {
              return removeItem(item);
            },
            color: "primary",
            deleteIcon: /*#__PURE__*/_jsx(Icon, {
              color: RaiseColors.science900,
              style: {
                marginRight: "11px"
              },
              fontSize: "16px",
              className: "fal fa-times"
            })
          }, _concatInstanceProperty(_context3 = "".concat(index, "#")).call(_context3, itemToString(item)));
        };
        var inputFieldProps = _objectSpread({
          InputLabelProps: _objectSpread({}, getLabelProps({
            shrink: multiple && selectedItems.length > 0 ? true : undefined // undefined b/c false causes shrink on MasterlistingSelect
          })),
          InputProps: getInputProps({
            notched: false,
            onChange: function onChange(e) {
              var _e$target;
              if (e.target.value === "") {
                clearSelection();
              }
              // Band-aid fix to graphene.List(graphene.String) not accepting commas.
              e.target.value = disableCommaInput ? e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 || (_e$target = _e$target.value) === null || _e$target === void 0 ? void 0 : _e$target.replace(/,/g, "") : e.target.value;
            },
            onClick: function onClick() {
              if (!isOpen && !muiFieldProps.disabled) {
                toggleMenu();
              }
            },
            onFocus: function onFocus(e) {
              e.target.select();
            },
            name: name,
            inputRef: inputFieldRef,
            startAdornment: multiple ? useRevampedMapItemToChip ? null : _mapInstanceProperty(selectedItems).call(selectedItems, mapItemToChip) : null
          })
        }, muiFieldProps);
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(DefaultAutocompleteInputField, _objectSpread({}, inputFieldProps)), useRevampedMapItemToChip ? _mapInstanceProperty(selectedItems).call(selectedItems, revampedMapItemToChip) : null, /*#__PURE__*/_jsx(DefaultSuggestionsPopper, {
            open: isOpen,
            anchorEl: function anchorEl() {
              return inputFieldRef === null || inputFieldRef === void 0 ? void 0 : inputFieldRef.current;
            },
            suggestions: suggestions,
            multiple: multiple,
            getMenuProps: getMenuProps,
            getItemProps: getItemProps,
            itemToString: itemToString,
            creatable: createable,
            inputValue: inputValue,
            selectItem: selectItem
          })]
        });
      }
    })
  });
}